var jade = require("/home/circleci/rentapplication-frontend/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<img" + (jade.attr("src", require('./../tip-lightbulb-copy-3.svg'), true, true)) + " width=\"56\" alt=\"\"><div style=\"width:240px;\"><h3>Use \"Send\" to email potential tenants a link to your application</h3></div><div class=\"dots\"><a href=\"#\" onClick=\"window.Shepherd.activeTour.show('form-step1')\" class=\"dot dot1-button\"></a><a href=\"#\" onClick=\"window.Shepherd.activeTour.show('form-step2')\" class=\"dot dot2-button\"></a><a href=\"#\" class=\"dot dot3-button active\"></a></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./components/dashboard/forms/tour/first_form/step3.jade
// module id = 741
// module chunks = 0